module.exports = __webpack_public_path__ + "media/images/top/qa/ranking_banner05-4cb9c2a6538f4ae071779e80ba4ac420.png";